import React from 'react'
import { faWallet } from '@fortawesome/free-solid-svg-icons'
import BaseModal from './BaseModal'

const RemittanceStatement = () => {
    return (
        <BaseModal modalId="modalRemittanceStatement" modalTitle="Remittance Statement" modalTitleIcon={faWallet}>
            RemittanceStatement
        </BaseModal>
    )
}

export default RemittanceStatement